import { useTranslation } from 'react-i18next';

import { Modal } from '../modal/Modal';

import styles from './AiAssistantModal.module.scss';

type DisclaimerModalProps = {
  onClose: () => void;
  opened: boolean;
};

export function DisclaimerModal({ onClose, opened }: DisclaimerModalProps) {
  const { t } = useTranslation();
  const translatedParagraphs = t('app.aiAssistant.disclaimerParagraphs', {
    returnObjects: true,
  });

  const paragraphs = Array.isArray(translatedParagraphs)
    ? translatedParagraphs
    : [translatedParagraphs];

  return (
    <Modal
      modalType="info"
      onClose={onClose}
      opened={opened}
      size={560}
      title={t('app.aiAssistant.disclaimerTitle')}
    >
      <div className={styles['info-text']}>
        {paragraphs.map((paragraph) => (
          <p key={String(paragraph)}>{String(paragraph)}</p>
        ))}
      </div>
    </Modal>
  );
}
